import React from "react";
import uploadimg from "../../assets/uploadicon.svg";
import eye from "../../assets/viewPdfEyeIcon.svg";
import { VIEW_ONLY_EMPTY_MESSAGE } from "../../hooks/useAdminPermissions";
import CoiCertificateLanguageToggle from "./CoiCertificateLanguageToggle";

const getStateNamesFromEntry = (entry) => {
  if (!entry?.stateName || entry.stateName === true) {
    return [];
  }

  if (Array.isArray(entry.stateName)) {
    return entry.stateName.filter(Boolean);
  }

  return [entry.stateName];
};

const CoiCertificateFileRow = ({ fileName = "", fileUrl = "" }) => {
  if (!fileName && !fileUrl) {
    return null;
  }

  return (
    <div className="dpc-extra-view-file coi-view-file">
      <div className="dpc-extra-view-file-details">
        <img src={uploadimg} alt="" />
        <span>{fileName || "Certificate.pdf"}</span>
      </div>
      {fileUrl ? (
        <a
          href={fileUrl}
          target="_blank"
          rel="noreferrer"
          className="dpc-extra-view-file-eye"
        >
          <img src={eye} alt="View file" />
        </a>
      ) : null}
    </div>
  );
};

const CoiCertificateViewOnlyAllState = ({ fileEntry }) => {
  const fileName = fileEntry?.fileName || "";
  const fileUrl = fileEntry?.url || fileEntry?.preSigned || "";

  return (
    <div className="sectionpadding bg-white mb-30 coi-view-panel">
      <p className="mb-3 heedprodct">Add Certificate</p>
      <hr />
      {fileName || fileUrl ? (
        <CoiCertificateFileRow fileName={fileName} fileUrl={fileUrl} />
      ) : (
        <p className="release-document-view-empty mb-0">
          {VIEW_ONLY_EMPTY_MESSAGE}
        </p>
      )}
    </div>
  );
};

const CoiCertificateViewOnlyStateWise = ({ stateEntries = [] }) => {
  const entriesWithContent = stateEntries.filter(
    (entry) =>
      getStateNamesFromEntry(entry).length > 0 ||
      entry?.fileName ||
      entry?.url ||
      entry?.preSigned,
  );

  if (!entriesWithContent.length) {
    return (
      <>
        <p className="heedprodct mb-20">Certificate</p>
        <div className="sectionpadding bg-white mb-30 coi-view-panel">
          <p className="release-document-view-empty mb-0">
            {VIEW_ONLY_EMPTY_MESSAGE}
          </p>
        </div>
      </>
    );
  }

  return (
    <>
      <p className="heedprodct mb-20">Certificate</p>
      {entriesWithContent.map((entry, index) => {
        const stateNames = getStateNamesFromEntry(entry);
        const fileName = entry?.fileName || "";
        const fileUrl = entry?.url || entry?.preSigned || "";

        return (
          <div
            className="sectionpadding bg-white mb-30 coi-view-panel"
            key={`${fileName}-${index}`}
          >
            <p className="coi-view-selected-label mb-3">Selected</p>
            <div className="coi-view-statewise-row">
              <div className="coi-view-states-box">
                {stateNames.length > 0 ? (
                  stateNames.map((stateName) => (
                    <span className="coi-view-state-tag" key={stateName}>
                      {stateName}
                    </span>
                  ))
                ) : (
                  <span className="coi-view-state-tag">-</span>
                )}
              </div>
              <CoiCertificateFileRow fileName={fileName} fileUrl={fileUrl} />
            </div>
          </div>
        );
      })}
    </>
  );
};

const CoiCertificateViewOnly = ({
  content,
  manageSwitch,
  setManageSwitch,
  isAllState = false,
}) => {
  const langData = manageSwitch ? content?.spanish : content?.english;
  const stateEntries = langData?.coi?.state || [];

  return (
    <>
      <CoiCertificateLanguageToggle
        manageSwitch={manageSwitch}
        setManageSwitch={setManageSwitch}
      />
      {isAllState ? (
        <CoiCertificateViewOnlyAllState
          fileEntry={
            stateEntries.find((entry) => entry?.url || entry?.fileName) ||
            stateEntries[0]
          }
        />
      ) : (
        <CoiCertificateViewOnlyStateWise stateEntries={stateEntries} />
      )}
    </>
  );
};

export default CoiCertificateViewOnly;
